import { FaShareAlt, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
// import { useState } from 'react';
// import { useEffect } from 'react';
// import axiosInstance from '../../../utils/axios';
// const Range = ({ percentage }) => {
//   return (
//     <div className="w-full border-2 border-gray-400 rounded-xl relative my-2">
//       {/* FILL */}
//       <div
//         style={{ right: `calc(${100 - percentage}%)` }}
//         className=" border-2 border-[#B250D2] rounded-xl absolute -translate-y-[50%] -left-0.5 transition-all ease-in-out duration-300"
//       ></div>

//       {/* BUBBLE */}
//       <div
//         style={{ left: `calc(${percentage}% - 16px)` }}
//         className="bubble absolute -translate-y-[50%]  bg-[#B250D2] py-1 px-1.5 text-white text-[0.5rem] rounded-lg transition-all ease-in-out duration-300"
//       >
//         {percentage}%
//       </div>
//     </div>
//   );
// };

const CampaignCard = ({ campaign }) => {
  const handleWhatsAppShare = (campaign) => {
    const message = `Check out this campaign: ${campaign.name}\n${window.location.origin}/campaigns/${campaign._id}`;
    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };
  const handleGeneralShare = (campaign) => {
    if (navigator.share) {
      navigator
        .share({
          title: campaign.name,
          text: `Check out this amazing campaign: ${campaign.name}`,
          url: `${window.location.origin}/campaigns/${campaign._id}`,
        })
        .catch((error) => console.log("Sharing failed:", error));
    } else {
      // fallback if share API isn’t supported
      const fallbackUrl = `${window.location.origin}/campaigns/${campaign._id}`;
      navigator.clipboard.writeText(fallbackUrl);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <Link to={`/campaigns/${campaign._id}`}>
        <div className="relative h-40 overflow-hidden">
          <img
            src={campaign.images[0]}
            alt={campaign.title || "Campaign image"}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-20" />
        </div>
      </Link>

      <div className="p-4 ">
        <Link to={`/campaigns/${campaign._id}`}>
          <h3 className="text-md font-semibold font-onest text-gray-800 mb-2 line-clamp-2 sm:min-h-12 text-ellipsis ">
            {campaign.name}
          </h3>
        </Link>
        <div className="flex items-center justify-start mt-1 text-gray-600 text-sm">
          {/* <button className="px-3 py-1.5 bg-orange-500 font-poppins hover:bg-orange-600 text-white font-semibold tracking-wide rounded-md text-[0.6rem] transition-colors">
                                               DONATE NOW
                                           </button> */}
          <div className="flex items-center gap-2 font-poppins font-normal">
            <span>Share:</span>
            <div className="flex gap-2 text-xl">
              <FaWhatsapp
                onClick={() => handleWhatsAppShare(campaign)}
                className="cursor-pointer text-green-600 hover:scale-110 transition-transform"
              />
              <FaShareAlt
                onClick={() => handleGeneralShare(campaign)}
                className="cursor-pointer text-blue-600 hover:scale-110 transition-transform"
              />
            </div>
          </div>
        </div>

        {/* <div className="pt-1">
          <Range percentage={campaign?.progress || 0} />
        </div>
        <div className="raised_and_goal pt-2 flex items-center justify-between text-[0.5rem] md:text-sm text-[#5C5C5C] font-poppins">
          <div className="raised">Raised: ₹{campaign.raised || 0}</div>
          <div className="goal">Goal: ₹{campaign.goal || 0}</div>
        </div> */}
      </div>
    </div>
  );
};

export default CampaignCard;
